import { Box, Card, ThemeProvider, Typography, createTheme } from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../shared/hooks/sharedHooks";
import colors from "../../../../shared/themes/colors";
import { ChangeOffer, CustomerSentOffersState } from "../../models/models";
import Title from "./details/Title";
import Main from "./details/Main";
import Additional from "./details/Additional";
import { useFormContext } from "react-hook-form";

const PreviewStep = () => {
  const { rfq } = useAppSelector<CustomerSentOffersState>(
    (state: any) => state.customerSentOffers
  );
  const { getValues } = useFormContext<ChangeOffer>();

  const model = getValues();

  const dispatch = useAppDispatch();
  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Box className="mt-5">
        <Box className="heading-1">Create new offer</Box>

        <Typography fontSize={20} fontWeight={500} className="text-20-medium flex">
          for{"\u00A0"}
          <span>
            <Typography fontSize={20} fontWeight={700}>
              {rfq?.buyer.name}
            </Typography>
          </span>
        </Typography>
      </Box>
      <Box className="mt-5">
        <Box className="heading-2">Preview — this is how the buyer sees your offer</Box>
      </Box>

      <Box className="flex justify-center">
        <Card className="w-min mt-4" elevation={0} sx={{ border: `1px solid ${colors.secondary.gray85}`, borderRadius: "5px" }}>
          <Box
            className="flex flex-col justify-between h-full"
            sx={{ width: 375, background: "#FFF", color: "#333", padding: "16px" }}
          >
            <Box>
              <Title name={rfq?.buyer.name} />

              <Main offer={model} className="mt-4" />

              <Additional offer={model} className="mt-4" />
            </Box>
          </Box>
        </Card>
      </Box>
    </ThemeProvider>
  );
};
export default PreviewStep;